import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';



class FilePicker extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className='FilePicker col form-group'>
				<label htmlFor={this.props.id}>{this.props.label}</label>
				<input type='file'
					className={cx('form-control-file', {"is-invalid": this.props.touched && this.props.errorMessage})}
					accept={this.props.acceptedExtensions.join(',')}
					id={this.props.id}
					onChange={this.props.onChange}
				/>
				{this.props.helperText &&
					<div className="small text-secondary">
						{this.props.helperText}
					</div>
				}
				{this.props.touched && this.props.errorMessage &&
					<React.Fragment>
						<div className='form-control is-invalid d-none'></div>
						<div className='invalid-feedback'>
							{this.props.errorMessage}
						</div>
					</React.Fragment>
				}
			</div>);
	}
}


FilePicker.propTypes = {
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	touched: PropTypes.bool.isRequired,
	errorMessage: PropTypes.string.isRequired,
	helperText: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
	acceptedExtensions: PropTypes.array
};

export default FilePicker;
